import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsOfService = () => {
  return (
    <>
      <div className="h-28"></div> {/* Dedicated spacer */}
      <div className="container mx-auto px-4 py-12">
        <Helmet>
          <title>Terms of Service - ZiwaTech</title>
          <meta name="description" content="ZiwaTech's terms of service outline the rules and guidelines for using our services." />
        </Helmet>

        <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8 text-primary">
          <i className="fa-solid fa-gavel mr-2"></i>
          Terms of Service
        </h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="mb-4">Last Updated: May 22, 2025</p>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Introduction</h2>
            <p>
              Welcome to ZiwaTech. These terms and conditions outline the rules and regulations for the use of ZiwaTech's website and services.
              By accessing this website or using our services, we assume you accept these terms and conditions in full. 
              Do not continue to use ZiwaTech's website or services if you do not accept all of the terms and conditions stated on this page.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Service Description</h2>
            <p className="mb-4">
              ZiwaTech provides professional device repair services for smartphones, computers, tablets, and game consoles. 
              Our services include but are not limited to screen replacements, battery replacements, water damage repair, 
              data recovery, and general troubleshooting.
            </p>
            <p>
              All repairs are subject to the availability of parts and the condition of your device. 
              We reserve the right to refuse service if we determine that a repair is not feasible or safe to perform.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Repair Warranty</h2>
            <p className="mb-4">
              ZiwaTech provides a 90-day limited warranty on parts and labor for most repairs. This warranty covers defects in 
              the parts used for repair and workmanship issues. The warranty does not cover:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Physical damage to the device after repair</li>
              <li>Water or liquid damage after repair</li>
              <li>Software issues unrelated to the repair</li>
              <li>Issues with parts not replaced during the repair</li>
              <li>Damage caused by unauthorized modifications or repairs</li>
            </ul>
            <p>
              To claim warranty service, you must present your original repair receipt and the device must be in the same 
              condition as when it was returned to you, except for the issue covered by warranty.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Payment and Pricing</h2>
            <p className="mb-4">
              Prices for our services are as listed on our website or as quoted by our technicians after device assessment. 
              Payment is due upon completion of the repair unless otherwise agreed upon. We accept various payment methods 
              including credit cards, debit cards, and cash.
            </p>
            <p>
              If during the repair process we discover additional issues that require attention, we will contact you with 
              a revised quote before proceeding with any additional work.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Data and Privacy</h2>
            <p>
              ZiwaTech is not responsible for any data loss that may occur during the repair process. We strongly recommend 
              that you back up your data before submitting your device for repair. While we take reasonable precautions to 
              protect your data, we cannot guarantee that data will not be lost, corrupted, or accessed by unauthorized parties 
              during the repair process.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by applicable law, ZiwaTech shall not be liable for any indirect, incidental, 
              special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or 
              indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from (a) your use or 
              inability to use our services; (b) any unauthorized access to or use of our servers and/or any personal 
              information stored therein; (c) any interruption or cessation of transmission to or from our services; 
              (d) any bugs, viruses, trojan horses, or the like that may be transmitted to or through our service by any 
              third party.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. If we make changes, we will provide notice of such 
              changes, such as by posting the revised terms to our website. Your continued use of our services following 
              the posting of revised terms means that you accept and agree to the changes.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us at:
              <br />
              Email: info@ziwatech.ca
              <br />
              Phone: +1647-200-2040
              <br />
              Address: A140-1 York Gate Blvd, North York, Toronto, ON M3N 3A1, Canada
            </p>
          </section>
        </div>
      </div>
      </div>
    </>
  );
};

export default TermsOfService;
